import { render } from "./MySurveys.vue?vue&type=template&id=10a9b749&scoped=true"
import script from "./MySurveys.vue?vue&type=script&lang=js"
export * from "./MySurveys.vue?vue&type=script&lang=js"

import "./MySurveys.vue?vue&type=style&index=0&id=10a9b749&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a9b749"]])

export default __exports__